import { Alert02Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const AlertTriangle = /* @__PURE__ */ createIcon(Alert02Icon, 'AlertTriangle');
